module.exports = __webpack_public_path__ + "img/wrapper_m_bg.2a5951f.webp";